import React from "react"
import { useNavigate } from "react-router-dom"
import ReactMarkdown from "react-markdown"

function NonActionableNotificationItem({ notification }) {
	const navigate = useNavigate()

	const handleClick = () => {
		if (notification.description.toLowerCase().includes("settings")) {
			navigate("/settings")
		} else {
			navigate("/ic-tracker")
		}
	}

	return (
		<div
			className={`relative bg-customBg shadow-sm rounded-md p-4 mb-4 flex items-center justify-between cursor-pointer ${
				notification.active ? "font-bold" : ""
			}`}
			onClick={handleClick}
		>
			<div className="flex items-center">
				<div className="mr-4">
					<span
						aria-label="icon"
						className="relative inline-flex items-center justify-center w-12 h-12 shadow-md rounded-full bg-white"
					>
						<span className="text-2xl">{notification.icon}</span>
						{notification.active && (
							<span className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full"></span>
						)}
					</span>
				</div>
				<div className="prose prose-slate prose-sm text-black prose-li:text-black sensitive ph-no-capture">
					<div className="font-bold mb-2 sensitive">{notification.notification_name}</div>
					<ReactMarkdown>{notification.description}</ReactMarkdown>
					<div className="text-gray-400 text-sm">{notification.time}</div>
				</div>
			</div>
		</div>
	)
}

export default NonActionableNotificationItem
